import { render, staticRenderFns } from "./TabsButtonMath.vue?vue&type=template&id=6dfa719c&scoped=true&lang=pug&"
import script from "./TabsButtonMath.vue?vue&type=script&lang=ts&"
export * from "./TabsButtonMath.vue?vue&type=script&lang=ts&"
import style0 from "./TabsButtonMath.vue?vue&type=style&index=0&id=6dfa719c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfa719c",
  null
  
)

export default component.exports